<div class="alert-modal-container">
  <div class="close-icon ion-padding" (click)="closeModal()" style="display: flex;">
    <img class="arrow ion-padding" src="../../../../assets/images/right-arrow.svg" alt="">&nbsp;&nbsp;
    <p>Continue to itiamc.com</p>
  </div>
  <!-- Desktop -->
  <div class="message-container content-web-section">
    <!-- <div class="message-text pan-adhaar-desktop" [ngStyle]="{'display': flag === 1 ? 'block' : 'none'}"
      (click)="redirectTo(flag)">
    </div>

    <div class="message-text nomination-updation-desktop" [ngStyle]="{'display': flag === 2 ? 'block' : 'none'}"
      (click)="redirectTo(flag)">
    </div>

    <div class="message-text vigilance-banner-desktop" [ngStyle]="{'display': flag === 3 ? 'block' : 'none'}"
      (click)="redirectTo(flag)">
    </div> -->
    <!-- <div id="Carousel" data-interval="3000" class="carousel slide" data-ride="carousel" >
      <ol class="carousel-indicators">
          <li *ngFor="let item of banners;let i=index;" data-target="#Carousel" class="{{ (i == 0) ? 'active' : '' }}" attr.data-slide-to="{{i}}"></li>
      </ol>
      <div class="carousel-inner">
        <ng-template ngFor let-item [ngForOf]="banners" let-i="index">
          <div  class="carousel-item " [ngClass]="{'active':i===0}" (click)="redirectTo(item.name)">
              <img class="message-text" [src]="'../../../../'+item.filePath" alt="Header Slide images"  />
          </div>
        </ng-template>
      </div>
  </div> -->
    <div class="message-text digital-kyc-desktop" (click)="redirectTo('KYC')">
    </div>
  </div>

  <!-- Mobile -->
  <div class="message-container content-mobile-section">
    <!-- <div class="message-text pan-adhaar-mobile" [ngStyle]="{'display': flag === 1 ? 'block' : 'none'}"
      (click)="redirectTo(flag)"></div>

    <div class="message-text nomination-updation-mobile" [ngStyle]="{'display': flag === 2 ? 'block' : 'none'}"
      (click)="redirectTo(flag)"></div>

    <div class="message-text vigilance-banner-mobile" [ngStyle]="{'display': flag === 3 ? 'block' : 'none'}"
      (click)="redirectTo(flag)"></div>
  </div> -->

    <div class="message-text digital-kyc-mobile" (click)="redirectTo('KYC')"></div>
  </div>
  <!-- <div id="Carousel" data-interval="3000" class="carousel slide" data-ride="carousel" >
    <ol class="carousel-indicators">
        <li *ngFor="let item of mobileBanners;let i=index;" data-target="#Carousel" class="{{ (i == 0) ? 'active' : '' }}" attr.data-slide-to="{{i}}"></li>
    </ol>
    <div class="carousel-inner">
      <ng-template ngFor let-item [ngForOf]="mobileBanners" let-i="index">
        <div  class="carousel-item " [ngClass]="{'active':i===0}" (click)="redirectTo(item.name)">
            <img class="message-text" [src]="'../../../../'+item.filePath" alt="Header Slide images"  />
        </div>
      </ng-template>
    </div>
</div> -->
</div>
